import { formatDate } from './format-date';

import { DeviceSharingPolicyItem, DeviceGrantPolicy } from '../types/devices';

export const EXPIRING_SOON_DAYS_THRESHOLD = 7;

export const getExpiresAt = (
  policies?: DeviceSharingPolicyItem[]
): string | undefined =>
  policies?.find((p) => p.device_grant_policy === DeviceGrantPolicy.EXPIRES_AT)
    ?.device_grant_policy_value;

export const getDaysUntilExpiry = (expiresAt: string): number => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const expiryDate = new Date(expiresAt);
  expiryDate.setHours(0, 0, 0, 0);
  const diffMs = expiryDate.getTime() - today.getTime();
  return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
};

export const isAccessExpiringSoon = (expiresAt: string): boolean => {
  const daysRemaining = getDaysUntilExpiry(expiresAt);
  return daysRemaining >= 0 && daysRemaining <= EXPIRING_SOON_DAYS_THRESHOLD;
};

export const isAccessExpired = (expiresAt: string): boolean => {
  return new Date(expiresAt) <= new Date();
};

export const formatAccessRemaining = (
  expiresAt: string
): {
  daysLeft: number | null;
  formattedDate: string;
  isExpiringSoon: boolean;
  isExpired: boolean;
} => {
  const daysLeft = getDaysUntilExpiry(expiresAt);
  const isExpired = isAccessExpired(expiresAt);

  if (daysLeft <= EXPIRING_SOON_DAYS_THRESHOLD) {
    return {
      daysLeft,
      formattedDate: formatDate(expiresAt),
      isExpiringSoon: true,
      isExpired
    };
  }

  return {
    daysLeft: null,
    formattedDate: formatDate(expiresAt),
    isExpiringSoon: false,
    isExpired: false
  };
};
